import { css } from 'styled-components'

const noEventOrSelectCss = css`
  user-select: none;
  pointer-events: none;
`

const preventUserInputCss = css`
  position: relative;
  ${({ isLoading }: { isLoading: boolean }) => (isLoading ? noEventOrSelectCss : '')};
`

export default preventUserInputCss
